// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__4lXHQ","options":"AnswerScale_options__1ac7V","selected":"AnswerScale_selected__1KGhm"};